<template>
  <div class="userlist">
    <template v-if="active === 'list'">
      <div class="userlist__item-wrapper">
        <div class="userlist__item userlist__item_head">
          <div class="userlist__block-text">#</div>
          <div class="userlist__item-img userlist__item-img_head">Image</div>
          <div class="userlist__item-name">Company</div>
          <div class="userlist__item-img userlist__item-img_head">Image</div>
          <div class="userlist__item-name">Company</div>
          <div class="userlist__item-phone">Phone</div>
          <div class="userlist__item-mail">Email</div>
          <div class="userlist__item-post">Address</div>
          <div class="userlist__item-buttons" style="width: 16%">
            Actions
          </div>
        </div>
      </div>
      <div class="userlist__wrapper" v-bar>
        <div class="userlist__block">
          <div class="userlist__items">
            <transition-group name="list" tag="div">
              <div
                v-for="(user, index) in usersData"
                :key="user.id"
                class="userlist__item-wrapper"
                :class="{ show: showSubItems === user.id }"
              >
                <div
                  class="userlist__item"
                  @click="toggleSubItems($event, user.id)"
                >
                  <div class="userlist__block-text">{{ index + 1 }}</div>
                  <div
                    class="userlist__item-img"
                    :style="{
                      backgroundImage: 'url(' + user.small_image + ')',
                    }"
                  ></div>
                  <div class="userlist__item-name" :title="user.company_name">
                    {{ user.company_name }}
                  </div>
                  <div
                    class="userlist__item-img"
                    :style="{
                      backgroundImage:
                        'url(' +
                        (user.owner ? user.owner.small_image : '') +
                        ')',
                    }"
                  ></div>
                  <div
                    class="userlist__item-name"
                    :title="
                      (user.owner ? user.owner.first_name : '') +
                        ' ' +
                        (user.owner ? user.owner.last_name : '')
                    "
                  >
                    {{ user.owner ? user.owner.first_name : "" }}
                    {{ user.owner ? user.owner.last_name : "" }}
                  </div>
                  <div
                    class="userlist__item-phone"
                    :title="user.owner ? user.owner.phone : ''"
                  >
                    {{ user.owner ? user.owner.phone : "" }}
                  </div>
                  <div
                    class="userlist__item-mail"
                    :title="user.owner ? user.owner.email : ''"
                  >
                    {{ user.owner ? user.owner.email : "" }}
                  </div>
                  <div
                    class="userlist__item-post"
                    :title="
                      user.owner && user.owner.address
                        ? $t('lists.street') +
                          ' ' +
                          user.owner.address.street +
                          ', ' +
                          user.owner.address.house +
                          ', ' +
                          $t('lists.office') +
                          user.owner.address.apartment +
                          ', ' +
                          user.owner.address.country +
                          ', ' +
                          user.owner.address.city
                        : $t('lists.addAddress')
                    "
                  >
                    {{user.owner && user.owner.address ? $t('lists.street') +' ' +
                                        user.owner.address.street + ', '+user.owner.address.house + ','
                      +$t('lists.office') + user.owner.address.apartment + ', '
                                        +user.owner.address.country + ', '+user.owner.address.city:
                                        $t('lists.addAddress')}}
                  </div>
                  <div class="userlist__item-buttons" @click.stop>
                    <div class="userlist__item-button">
                      <svg
                        class="icon"
                        @click="
                          openCall(
                            user.owner.id,
                            user.owner.last_name,
                            user.owner.first_name,
                            user.owner.small_image,
                            true
                          )
                        "
                      >
                        <use
                          xlink:href="/images/svg/symbols.svg#svg-user-phone"
                        ></use>
                      </svg>
                    </div>
                    <div class="userlist__item-button">
                      <svg
                        class="icon"
                        @click="
                          openCall(
                            user.owner.id,
                            user.owner.last_name,
                            user.owner.first_name,
                            user.owner.small_image,
                            false
                          )
                        "
                      >
                        <use
                          xlink:href="/images/svg/symbols.svg#svg-user-video"
                        ></use>
                      </svg>
                    </div>
                    <div
                      class="userlist__item-button"
                      v-if="user.owner"
                      @click="editCompanyOpen(user.id, user.owner.id)"
                    >
                      <svg class="icon">
                        <use
                          xlink:href="/images/svg/symbols.svg#svg-user-message"
                        ></use>
                      </svg>
                    </div>
                    <div
                      class="userlist__item-button"
                      @click="deleteCompanyOpen(user.id)"
                    >
                      <svg class="icon">
                        <use
                          xlink:href="/images/svg/symbols.svg#svg-user-del"
                        ></use>
                      </svg>
                    </div>
                    <div
                      class="userlist__item-button"
                      @click="addApplication(user.id, user.owner.id)"
                    >
                      <svg class="icon">
                        <use
                          xlink:href="/images/svg/symbols.svg#svg-add-work"
                        ></use>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="userlist__subitems" @click.stop>
                  <transition-group name="list" tag="div">
                    <div
                      class="userlist__item userlist__item--sub"
                      v-for="employee in employees"
                      :key="employee.id"
                    >
                      <div
                        class="userlist__item-img"
                        :style="{
                          backgroundImage: 'url(' + employee.small_image + ')',
                        }"
                      ></div>
                      <div
                        class="userlist__item-name"
                        :title="user.first_name + ' ' + user.last_name"
                      >
                        {{ employee.first_name }}
                        {{ employee.last_name }}
                      </div>
                      <div class="userlist__item-phone" :title="employee.phone">
                        {{ employee.phone }}
                      </div>
                      <div class="userlist__item-mail" :title="employee.email">
                        {{ employee.email }}
                      </div>
                      <div
                        class="userlist__item-post"
                        :title="
                          employee.address
                            ? $t('lists.street') +
                              ' ' +
                              employee.address.street +
                              ', ' +
                              employee.address.house +
                              ', ' +
                              $t('lists.office') +
                              employee.address.apartment +
                              ', ' +
                              employee.address.country +
                              ', ' +
                              employee.address.city
                            : $t('lists.addAddress')
                        "
                      >
                        {{employee.address ? $t('lists.street') +' ' + employee.address.street +
                                                ', '+employee.address.house + ', '+$t('lists.office') +
                                                employee.address.apartment + ', ' +employee.address.country +
                          ','+employee.address.city: $t('lists.addAddress')}}
                      </div>
                      <div class="userlist__item-buttons">
                        <div class="userlist__item-button">
                          <svg
                            class="icon"
                            @click="
                              openCall(
                                employee.id,
                                employee.last_name,
                                employee.first_name,
                                employee.small_image,
                                true
                              )
                            "
                          >
                            <use
                              xlink:href="/images/svg/symbols.svg#svg-user-phone"
                            ></use>
                          </svg>
                        </div>
                        <div class="userlist__item-button">
                          <svg
                            class="icon"
                            @click="
                              openCall(
                                employee.id,
                                employee.last_name,
                                employee.first_name,
                                employee.small_image,
                                false
                              )
                            "
                          >
                            <use
                              xlink:href="/images/svg/symbols.svg#svg-user-video"
                            ></use>
                          </svg>
                        </div>
                        <div
                          class="userlist__item-button"
                          @click="
                            editEmployeeOpen(
                              user.id,
                              employee.id,
                              user.big_image
                            )
                          "
                        >
                          <svg class="icon">
                            <use
                              xlink:href="/images/svg/symbols.svg#svg-user-message"
                            ></use>
                          </svg>
                        </div>
                        <div
                          class="userlist__item-button"
                          @click="
                            deleteCompanyEmployeeOpen(user.id, employee.id)
                          "
                        >
                          <svg class="icon">
                            <use
                              xlink:href="/images/svg/symbols.svg#svg-user-del"
                            ></use>
                          </svg>
                        </div>
                        <div
                          class="userlist__item-button"
                          @click="addApplication(user.id, employee.id)"
                        >
                          <svg class="icon">
                            <use
                              xlink:href="/images/svg/symbols.svg#svg-add-work"
                            ></use>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                  <div
                    class="userlist__add-user"
                    @click="addCompanyUserOpen(user.id, user.big_image)"
                  >
                    <svg class="icon">
                      <use
                        xlink:href="/images/svg/symbols.svg#svg-add-new"
                      ></use>
                    </svg>
                    <span>{{ $t("lists.addNewCompanyEmployee") }}</span>
                    <div class="load-wrapp" v-if="waitEmpoyees">
                      <div class="load-3">
                        <div class="line"></div>
                        <div class="line"></div>
                        <div class="line"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition-group>
            <div class="userlist__item" v-if="usersData.length === 0">
              {{ $t("lists.listEmpty") }}
            </div>
          </div>
        </div>
      </div>
      <div class="userlist__add">
        <div class="userlist__add-text">
          {{ addEmployeeTitle }}
        </div>
        <div class="userlist__add-button" @click="addCompanyOpen"></div>
      </div>
    </template>
    <UserMap
      v-else
      :updated="usersData"
      @deleteOpen="deleteCompanyOpen"
      :typeMap="typeMap"
    ></UserMap>
    <modal :show="showModalEmployee" @close="closeModal" :dark="true">
      <transition name="showmodal">
        <modal-company
          :typeAction="typeAction"
          v-if="showModalEmployee"
          :typeEmployee="typeEmployee"
          :request="request"
          :dataEmployee="userData"
          @okAction="empoloyeeConfirm"
          :companyId="companyId"
          :companyImage="companyImage"
          @cancelAction="closeModal"
          @setAvatar="setAvatarConfirm"
          @updateAvatar="updateAvatarConfirm"
          @setCompanyAvatar="setAvatarCompanyConfirm"
          @updateCompanyAvatar="updateAvatarCompanyConfirm"
          :edit="edit"
          transfer=""
        ></modal-company>
      </transition>
    </modal>

    <modal :show="showModalDelete" @close="closeModal" :dark="true">
      <delete-modal :cancelAction="closeModal" :okAction="deleteConfirm">
        {{ deleteTitle }}
      </delete-modal>
    </modal>

    <modal :show="showModalAdd" @close="closeModal" :dark="true">
      <transition name="showmodal">
        <add-application
          :dataEmployee="userData"
          v-if="showModalAdd"
          @addNewApplication="addNewRequest"
        ></add-application>
      </transition>
    </modal>
  </div>
</template>
<script>
import animateScrollTo from 'animated-scroll-to'

export default {
    props: [
        'active',
        'typeMap',
        'usersData',
        'userData',
        'addEmployee',
        'editCompany',
        'editEmployee',
        'deleteCompany',
        'deleteCompanyEmployee',
        'getCompany',
        'newUserData',
        'setEmployeeAvatar',
        'updateEmployeeAvatar',
        'setCompanyAvatar',
        'updateCompanyAvatar',
        'request',
        'newCompanyTitle',
        'addEmployeeTitle',
        'getCompaniesEmployee',
        'getCompanyEmpoloyeeData',
        'employees',
        'waitEmpoyees',
        'addCompany',
        'employeeData',
        'resetEmployeesData',
    ],
    data() {
        return {
            showModalEmployee: false,
            showModalDelete: false,
            showModalAdd: false,
            typeAction: 'company',
            typeEmployee: '',
            employeeId: '',
            companyId: '',
            showSubItems: false,
            deleteTitle: '',
            companyImage: '',
            edit: '',
        }
    },
    methods: {
        closeModal() {
            this.showModalEmployee = false
            this.showModalDelete = false
            this.showModalAdd = false
        },
        addCompanyOpen() {
            this.$store.commit('udpateObject', { data: 'employeeData' })
            this.showModalEmployee = true
            this.typeAction = 'company'
            this.edit = false
            this.typeEmployee = this.newCompanyTitle
        },
        addCompanyUserOpen(employeeId, companyImage) {
            this.$store.commit('udpateObject', { data: 'employeeData' })
            this.employeeId = employeeId
            this.showModalEmployee = true
            this.typeAction = 'company user'
            this.edit = false
            this.typeEmployee = this.newCompanyUserTitle
            this.companyImage = companyImage
        },
        editEmployeeOpen(companyId, employeeId, companyImage) {
            this.$store.commit('udpateObject', { data: 'employeeData' })
            this.showModalEmployee = true
            this.typeAction = 'company user'
            this.edit = true
            this.employeeId = employeeId
            this.companyId = companyId
            this.companyImage = companyImage
            this.$emit('getCompanyEmpoloyeeData', companyId, employeeId)
        },
        editCompanyOpen(companyId, employeeId) {
            this.$store.commit('udpateObject', { data: 'employeeData' })
            this.showModalEmployee = true
            this.typeAction = 'company'
            this.edit = true
            this.companyId = companyId
            this.employeeId = employeeId
            this.$emit('getCompany', this.companyId)
        },
        empoloyeeConfirm() {
            if (this.typeAction === 'company user') {
                if (this.edit) {
                    this.$emit('editEmployee', this.companyId, this.employeeId)
                } else {
                    this.$emit('addEmployee', this.employeeId)
                }
            } else if (this.typeAction === 'company') {
                if (this.edit) {
                    this.$emit('editCompany', this.companyId, this.employeeId)
                } else {
                    this.$emit('addCompany')
                }
            }
        },
        toggleSubItems(event, id) {
            this.$emit('resetEmployeesData')
            if (this.showSubItems === id) {
                this.showSubItems = false
            } else {
                this.showSubItems = id
                this.$emit('getCompaniesEmployee', id)
                setTimeout(() => {
                    const offSetEl = event.target.closest('.userlist__item-wrapper')
                        .offsetTop
                    const itemBox = document.querySelector('.userlist__block')
                    if (offSetEl < itemBox.scrollTop) {
                        animateScrollTo(offSetEl, { speed: 1000, element: itemBox })
                    }
                }, 500)
            }
        },
        deleteCompanyOpen(id) {
            this.showModalDelete = true
            this.deleteTitle = this.$t('lists.deleteCompanyMess')
            this.employeeId = ''
            this.companyId = id
        },
        deleteCompanyEmployeeOpen(companyId, employeeId) {
            this.showModalDelete = true
            this.employeeId = employeeId
            this.companyId = companyId
            this.deleteTitle = this.$t('lists.deleteCompanyEmployeeMess')
        },
        deleteConfirm() {
            this.showModalDelete = false
            if (this.employeeId && this.companyId) {
                this.$emit('deleteCompanyEmployee', this.companyId, this.employeeId)
            } else {
                this.$emit('deleteCompany', this.companyId)
            }
        },
        setAvatarConfirm(data, type) {
            this.$emit('setEmployeeAvatar', data, type)
        },
        updateAvatarConfirm(data) {
            this.$emit('updateEmployeeAvatar', this.companyId, this.employeeId, data)
        },
        setAvatarCompanyConfirm(data) {
            this.$emit('setCompanyAvatar', data)
        },
        updateAvatarCompanyConfirm(data) {
            this.$emit('updateCompanyAvatar', this.companyId, data)
        },
        addApplication(companyId, employeeId) {
            this.showModalAdd = true
            this.$emit('getCompanyEmpoloyeeData', companyId, employeeId)
        },
        addNewRequest(data) {
            this.$Progress.start()
            this.$store.dispatch('addApplication', data).then(() => {
                this.showModalAdd = false
                this.$Progress.finish()
            })
        },
        openCall(id, firstName, lastName, photo, isAudioCall) {
            const user = {
                fullName: `${firstName} ${lastName}`,
                photo,
                id,
                type: 'clients',
                isAnswer: false,
                isAudioCall,
            }
            this.$store.dispatch('showCallModal', user)
        },
    },
}
</script>
<style lang="scss" scoped>
@import "src/assets/sass/main";

.userlist {
  border-radius: 8px;
  background-color: #ffffff;
  width: 100%;
  height: calc(100% - 86px);
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);

  &__wrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 24px;
    box-sizing: border-box;
  }

  &__add {
    position: absolute;
    right: 25px;
    bottom: -25px;
    display: flex;
    align-items: flex-end;

    &-text {
      color: #4d4d4d;
      font-size: 12px;
      margin-right: 16px;
      font-family: $fontMedium;
    }

    &-button {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: $primaryColor;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-image: url("/images/icon/add.svg");
      background-position: center;
      background-size: 20px;
      background-repeat: no-repeat;
      transition: 0.5s;
      cursor: pointer;

      &:hover {
        background-color: $secondColor;
      }
    }
  }

  &__block {
    display: flex;
    position: relative;

    &-text {
      position: absolute;
      left: 0;
      top: 0;
      width: 64px;
      flex-shrink: 0;
      font-family: $fontLight;
      font-size: 30px;
      color: #e0e0e0;
      text-align: center;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
  }

  &__items {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    // padding-bottom: 24px;
  }

  &__item {
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
    flex-grow: 1;
    transition: 0.5s;
    padding-left: 64px;
    box-sizing: border-box;

    &_head {
      font-family: $fontBold;
      font-size: 14px;
      color: #4d4d4d;
    }

    &:hover {
      background-color: rgba(#71bd4a, 0.15);

      & .userlist__item-button {
        opacity: 1;
      }
    }

    &-img {
      width: 36px;
      height: 36px;
      background-position: center;
      background-size: cover;
      border: 1px solid $secondColor;
      border-radius: 50%;
      margin-right: 16px;
      margin-left: 5px;

      &_head {
        border: none;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 16px;
      }
    }

    &-name {
      font-size: 14px;
      color: #4d4d4d;
      font-family: $fontBold;
      flex-grow: 1;
      width: 10%;
      padding-left: 1px;
      padding-right: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-post {
      font-size: 12px;
      color: #4d4d4d;
      flex-grow: 1;
      width: 10%;
      padding-left: 1px;
      padding-right: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-phone {
      font-size: 14px;
      color: #4d4d4d;
      flex-grow: 1;
      width: 10%;
      padding-left: 1px;
      padding-right: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-mail {
      font-size: 14px;
      color: #4d4d4d;
      flex-grow: 1;
      width: 10%;
      padding-left: 1px;
      padding-right: 1px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &-status {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: $primaryColor;
      margin-left: 23px;
      margin-right: 23px;

      &--busy {
        background-color: $secondColor;
      }
    }

    &-buttons {
      display: flex;
      align-items: center;
      margin-left: 10px;
      flex-shrink: 0;
    }

    &-button {
      margin-right: 16px;
      opacity: 0;
      transition: 0.5s;
      cursor: pointer;

      &:nth-of-type(1) {
        transition-delay: 0s;
      }

      &:nth-of-type(2) {
        transition-delay: 0.1s;
      }

      &:nth-of-type(3) {
        transition-delay: 0.2s;
      }

      &:nth-of-type(4) {
        transition-delay: 0.3s;
      }

      &:nth-of-type(5) {
        transition-delay: 0.4s;
      }

      & .icon {
        width: 30px;
        height: 30px;
        transition: 0.5s;

        &:hover {
          transform: scale(1.2);
        }
      }
    }

    &-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      cursor: pointer;
    }

    &--sub {
      margin-left: calc(36px + 16%);

      & .userlist__item-name {
        width: 5%;
      }

      & .userlist__item-mail {
        width: 5%;
      }

      & .userlist__item-phone {
        width: 5%;
      }

      & .userlist__item-post {
        width: 5%;
      }

      & .userlist__item-buttons {
        flex-grow: 3;
      }
    }
  }

  &__subitems {
    transform: scaleY(0);
    transform-origin: top center;
    opacity: 0;
    position: absolute;
    border-bottom: 1px solid $primaryColor;
  }

  &__add-user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 50px;
    font-size: 12px;
    color: #4d4d4d;
    width: 100%;
    padding-left: calc(110px + 16%);

    & .icon {
      width: 30px;
      margin-right: 19px;
    }

    & .load-wrapp {
      margin-left: 20px;
      position: relative;
      bottom: 10px;
    }
  }
}

.show .userlist__subitems {
  transition: 0.3s;
  opacity: 1;
  transform: scale(1);
  height: initial;
  position: static;
}

.list-enter-active {
  transition: all 0.5s;
}

.list-leave-active {
  transition: all 0.5s;
  position: absolute;
  // transform: translateY(-30px);
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
</style>
